/* Sleepee 12.10 (uwaga klienta P0.5): ulubione bez konta — lista uchwytów produktów w localStorage tej przeglądarki.
   Serce na kartach (.mk-heart[data-wish]), na karcie produktu (obok nazwy) i w nagłówku (telefon + komputer) z licznikiem;
   lista na /pages/wishlist (sections/sleepee-wishlist.liquid) — karty pobierane widokiem ?view=sleepee-card.
   Konfiguracja: window.SleepeeWish z snippets/sleepee-wishlist-init.liquid. */
(function () {
  var KEY = 'sleepee_wishlist', C = window.SleepeeWish || {};
  function get() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function set(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, 60))); } catch (e) {} paint(); }
  function toggle(h) { var a = get(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); set(a); }
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-7.5-4.4-7.5-10A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.9c0 5.6-7.5 10-7.5 10z"/></svg>';

  function paint() {
    var a = get();
    Array.prototype.forEach.call(document.querySelectorAll('[data-wish]'), function (el) {
      var on = a.indexOf(el.getAttribute('data-wish')) > -1;
      el.classList.toggle('is-on', on); el.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lb = el.getAttribute(on ? 'data-label-on' : 'data-label-off'); if (lb) el.setAttribute('aria-label', lb); // 18.10 (audyt #22): etykieta „Usuń z ulubionych” po dodaniu
    });
    Array.prototype.forEach.call(document.querySelectorAll('.sl-wish-count'), function (el) { el.textContent = a.length || ''; el.hidden = !a.length; });
  }

  function mountHeader() {
    var url = (C.url || '/pages/wishlist');
    [['.header__mobile__right', 'header__mobile__button'], ['.header__desktop__buttons', 'header__desktop__button']].forEach(function (p) {
      var box = document.querySelector(p[0]);
      if (!box || box.querySelector('.sl-wish-link')) return;
      var d = document.createElement('div'); d.className = p[1] + ' sl-wish-head';
      d.innerHTML = '<a class="navlink sl-wish-link" href="' + url + '" title="' + (C.label || 'Wishlist') + '">' + HEART + '<span class="visually-hidden">' + (C.label || 'Wishlist') + '</span><span class="sl-wish-count" hidden></span></a>';
      var cart = box.querySelector('[class*="navlink--cart"]');
      var before = cart ? cart.closest('.' + p[1]) : null;
      box.insertBefore(d, before || null);
    });
  }

  function mountPdp() {
    if (!C.handle) return;
    var wrap = document.querySelector('.product__title__wrapper');
    if (!wrap || wrap.querySelector('.sl-wish-pdp')) return;
    var b = document.createElement('button'); b.type = 'button'; b.className = 'sl-wish-pdp'; b.setAttribute('data-wish', C.handle);
    b.setAttribute('aria-label', C.add || 'Add to wishlist'); b.innerHTML = HEART;
    wrap.classList.add('sl-wish-wrap'); wrap.appendChild(b);
  }

  function renderPage() {
    var box = document.querySelector('[data-wish-list]');
    if (!box) return;
    var a = get(), empty = document.querySelector('[data-wish-empty]');
    if (empty) empty.hidden = a.length > 0;
    box.hidden = !a.length;
    if (!a.length) { box.innerHTML = ''; return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Promise.all(a.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=sleepee-card').then(function (r) { return r.ok ? r.text() : (r.status === 404 ? null : ''); }).catch(function () { return ''; });
    })).then(function (parts) {
      /* produkt usunięty lub wycofany (404) znika z listy i z licznika */
      var dead = a.filter(function (h, i) { return parts[i] === null; });
      if (dead.length) { try { localStorage.setItem(KEY, JSON.stringify(a.filter(function (h) { return dead.indexOf(h) < 0; }))); } catch (e) {} }
      /* 3.11: uchwyt z listy (język kliknięcia), nie z karty w bieżącym języku — inaczej serce puste i duplikat */
      box.innerHTML = parts.map(function (p, i) { return p ? p.replace(/data-wish="[^"]*"/g, 'data-wish="' + String(a[i]).replace(/"/g, '') + '"') : ''; }).join('');
      var left = get().length; box.hidden = !left; if (empty) empty.hidden = left > 0;
      paint();
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-wish]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    toggle(el.getAttribute('data-wish'));
    if (document.querySelector('[data-wish-list]') && !el.classList.contains('is-on')) renderPage();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-wish]');
    if (!el || el.tagName === 'BUTTON') return;
    e.preventDefault(); e.stopPropagation(); toggle(el.getAttribute('data-wish'));
  }, true);

  function init() { mountHeader(); mountPdp(); paint(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('sleepee:wish:repaint', paint);
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paint(); renderPage(); } });
})();
